import React, { useEffect, useState } from 'react';

import * as Core from '../../core';
import { useLeague } from '../../hooks/store';
import { LeagueService } from '../../services/leagueService';
import { SeasonService } from '../../services/seasonService';

import './ncbcGames.scss';

const playHasStarted = (categories: Core.Models.SeasonCategory[]) =>
    categories.some((category) =>
        category.seasons.some(
            (season) => season.isVisible && season.currentState === Core.Models.CompetitionState.InProgress
        )
    );

const NcbcGames = (): JSX.Element => {
    const league = useLeague();
    const isNcbc = league?.featureGroup === Core.Models.FeatureGroup.NCBC;
    const [assets, setAssets] = useState<Core.Models.LeagueComingSoonAsset[] | undefined>(undefined);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!isNcbc) {
            setVisible(false);
            return;
        }

        let cancelled = false;
        Promise.all([LeagueService.getComingSoonAssets(), SeasonService.getAllSeasonCategories()])
            .then(([nextAssets, categories]) => {
                if (cancelled) return;
                setAssets(nextAssets);
                setVisible(!playHasStarted(categories));
            })
            .catch(() => {
                if (cancelled) return;
                setAssets([]);
                setVisible(true);
            });

        return () => {
            cancelled = true;
        };
    }, [isNcbc]);

    if (!isNcbc || !visible || !assets) return <></>;

    return (
        <section className="ncbc-games" aria-labelledby="ncbc-games-title">
            <div className="ncbc-games__intro">
                <p className="ncbc-games__kicker">National competition</p>
                <h2 className="ncbc-games__title" id="ncbc-games-title">
                    NCBC Games
                </h2>
                <p className="ncbc-games__lede">
                    The titles in this year’s championship. Register now — sessions open once your season starts.
                </p>
            </div>
            {assets.length === 0 ? (
                <p className="ncbc-games__empty">Game art will be posted here.</p>
            ) : (
                <div className="ncbc-games__grid">
                    {assets.map((asset) => (
                        <article className="ncbc-games__card" key={asset.id}>
                            <img alt="" src={asset.imageUrl} />
                            <div className="ncbc-games__shade" />
                            <h3 className="ncbc-games__name">{asset.name}</h3>
                        </article>
                    ))}
                </div>
            )}
        </section>
    );
};

export default NcbcGames;
